import SelectTag from "./select_tag";

export default class SearchSelect extends SelectTag {
  constructor(node) {
    super(node);
    this.element = node;
    this.optionsWrapperElement = this.dropdownElement.querySelector(".js-options-wrapper");
    this.orderNumbers = this.optionsWrapperElement.querySelectorAll(".js-order-number-wrapper");
    this.noResultsElement = this.dropdownElement.querySelector(".js-no-results-element");

    this.addInputFieldEventListeners();

    this.dropdownElement.addEventListener("click", (e) => {
      this.handleOptionClick(e);
    });
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
    this.selectBtn.setAttribute("aria-expanded", this.selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true");

    const event = new Event("select-dropdown-toggled");
    this.inputField.dispatchEvent(event);

    if (this.dropdownVisible) {
      document.body.appendChild(this.dropdownElement);
      this.setDropdownPosition();
      document.addEventListener("click", this.boundFunction);
    } else {
      document.removeEventListener("click", this.boundFunction);
      this.dropdownElement.remove();
    }
  }

  handleOptionClick(e) {
    const target = e.target;

    const selectValue = target.querySelector(".js-select-value");

    if (selectValue && target.tagName === "LABEL") {
      // Removes all strong tags that were generated as a search highlight.
      this.selectedValue.innerHTML = selectValue.innerHTML.replace(/<(\/?|\!?)(strong)>/g, "");
      this.selectedValue.dataset.orderNumber = selectValue.parentElement.dataset.value;
    }
  }

  addInputFieldEventListeners() {
    this.inputField.addEventListener("select-dropdown-toggled", () => {
      this.inputField.value = "";

      this.orderNumbers.forEach((orderNumber) => {
        orderNumber.classList.remove("d-none");
      });

      this.noResultsElement.classList.add("d-none");
      this.generateOptions();
    });

    this.inputField.addEventListener("keyup", (e) => {
      if (e.keyCode == 27) {
        this.selectBtn.dispatchEvent(new Event("click"));
      } else {
        this.orderNumbers.forEach((orderNumber) => {
          orderNumber.classList.toggle("d-none", !orderNumber.dataset.value.match(RegExp(`${this.inputField.value}`, "i")));
        });

        this.checkIfNoResults();

        this.generateOptions(this.inputField.value);
      }
    });
  }

  checkIfNoResults() {
    this.noResultsElement.classList.toggle("d-none", this.optionsWrapperElement.querySelectorAll(".js-order-number-wrapper.d-none").length !== this.orderNumbers.length);
  }
  generateOptions(query = "") {
    this.orderNumbers.forEach((orderNumber) => {
      const orderNumberText = orderNumber.querySelector(".js-order-number-text");

      const orderNumberFormatted = query ? orderNumberText.innerText.replace(query.toUpperCase(), `<strong>${query.toUpperCase()}</strong>`) : orderNumberText.innerText;
      const checked = this.inputElement.value == orderNumberText.innerText ? true : false;

      orderNumberText.innerHTML = orderNumberFormatted;

      orderNumber.querySelector("input[type='radio']").checked = checked;
    });
  }
}
